import styled from 'styled-components'
import AppButton from 'Components/AppButton'

import { OUTLINE_COLOR } from '@CSSVars/colors'

export const _ListingLockCard = styled.div`
  width: 286px;
  padding: 16px;
  background-color: white;
  border-radius: 10px;
`

export const _CardTitle = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 16px;
`

export const _Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const _AppButtonCta = styled(AppButton)`
  width: 121px;

  ${({ isLoginStyle }) => (
    isLoginStyle ?
      `
        border-color: ${OUTLINE_COLOR};
        margin-right: 12px;
      ` : ''
  )}
`
